import "@abraham/reflection";
function isTypeProvider(provider) {
    return 'type' === provider.type;
}
function isValueProvider(provider) {
    return 'value' === provider.type;
}
function isFactoryProvider(provider) {
    return 'factory' === provider.type;
}
const INJECTABLE_METADATA_KEY = Symbol('injectable');
const INJECT_METADATA_KEY = Symbol('inject');
const OPTIONAL_METADATA_KEY = Symbol('optional');
const INJECT_PROPERTY_METADATA_KEY = Symbol('inject-property');
const OPTIONAL_PROPERTY_METADATA_KEY = Symbol('optional-property');
export { INJECTABLE_METADATA_KEY, INJECT_METADATA_KEY, INJECT_PROPERTY_METADATA_KEY, OPTIONAL_METADATA_KEY, OPTIONAL_PROPERTY_METADATA_KEY, isFactoryProvider, isTypeProvider, isValueProvider };
